import { LinearProgress } from '@mui/material'
import { TopGainersCardLayout } from './TopGainersCardLayout'

export function TopGainersCardSkeleton() {
  return <TopGainersCardLayout content={<LinearProgress />}></TopGainersCardLayout>
}
